import { p as parseTransformString } from './parseTransformString-b447d498.js';
import { t as transformIsMeaningful } from './transformIsMeaningful-fde42595.js';

/** Converts the given transform string into an object containing CSS for the svg groups */
const getSVGTransformer = (width, transformString) => {
  const transform = parseTransformString(transformString);
  if (transform && transformIsMeaningful(transform)) {
    const outer = {
      transform: `translate(${String(width / 2)} 256)`
    };
    const innerTranslate = `translate(${String(transform.x * 32)}, ${String(transform.y * 32)})`;
    const innerScale = `scale(${String(transform.size / 16 * (transform.flipX ? -1 : 1))}, ${String(transform.size / 16 * (transform.flipY ? -1 : 1))})`;
    const innerRotate = `rotate(${String(transform.rotate)} 0 0)`;
    const inner = {
      transform: `${innerTranslate} ${innerScale} ${innerRotate}`
    };
    const path = {
      transform: `translate(${String(width / 2 * -1)} -256)`
    };
    return {
      outer,
      inner,
      path
    };
  }
  return null;
};
var getSVGTransformer$1 = getSVGTransformer;

export { getSVGTransformer$1 as g };
//# sourceMappingURL=getSVGTransformer-4490cfed.js.map
